<template>
  <div>
    <span v-for="piece in textArr" :key="piece.id">
      <span v-if="piece.type === 'text'" v-html="piece.text"></span>
      <a
        v-if="piece.type === 'ext'"
        :href="piece.link"
        target="_blank"
        class="text-link"
        >{{ piece.text }}</a
      >
      <span
        v-if="piece.type === 'int'"
        @click="$emit('openArticle', Number(piece.link))"
        class="text-link"
        >{{ piece.text }}</span
      >
    </span>
  </div>
</template>

<script>
export default {
  name: 'TextWithLinks',
  props: {
    text: String,
  },
  data() {
    return {
      textArr: [],
    };
  },
  mounted() {
    this.textArr = this.generateTextArray(this.text);
  },
  watch: {
    text() {
      this.textArr = this.generateTextArray(this.text);
    },
  },
  methods: {
    generateTextArray(text) {
      const result = [];
      let pos = 0;
      const linkPattern = /\[(https?:\/\/[^\]|]+|id=[^\]|]+)\|([^\]]+)\]/g;
      let match;
      while ((match = linkPattern.exec(text)) !== null) {
        if (match.index > pos) {
          result.push({
            id: match.index,
            type: 'text',
            text: text.slice(pos, match.index).replace(/\r\n/g, '<br>'),
          });
        }
        if (match[1].startsWith('id=')) {
          result.push({
            id: match.index,
            type: 'int',
            text: match[2],
            link: match[1].slice(3),
          });
        } else {
          result.push({
            id: match.index,
            type: 'ext',
            text: match[2],
            link: match[1],
          });
        }
        pos = linkPattern.lastIndex;
      }
      if (pos < text.length) {
        result.push({
          id: pos + 1,
          type: 'text',
          text: text.slice(pos).replace(/\r\n/g, '<br>'),
        });
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-link {
  color: var(--color-blue);
  text-decoration: underline;
  cursor: pointer;
}
</style>
